import { CrossSellProductActions } from '../constants/cross_sell_product/cross_sell_product_actions';
import Dispatcher from '../dispatcher';

export function setAction(products) {
  Dispatcher.handleCrossSellProductsAction({
    type: CrossSellProductActions.SET_PRODUCT,
    payload: products,
  });
}

export function addAction(product) {
  Dispatcher.handleCrossSellProductsAction({
    type: CrossSellProductActions.ADD_PRODUCT,
    payload: product,
  });
}

export function removeAction(productId) {
  Dispatcher.handleCrossSellProductsAction({
    type: CrossSellProductActions.REMOVE_PRODUCT,
    payload: productId,
  });
}

export function updateAction(product) {
  Dispatcher.handleCrossSellProductsAction({
    type: CrossSellProductActions.UPDATE_PRODUCT,
    payload: product,
  });
}
